
// Convert file to base64 string
export const toBase64 = (file) => {

    //console.log("file: ", file);

    return new Promise((resolve, reject) => {

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);

    });

};

// Convert an image url into a base64 image by first creating a tempory blob url
export const toBase64FromUrl = async (url) => {

    const response = await fetch(url);

    const blob = await response.blob();

    return new Promise((resolve, reject) => {

        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};